"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeWarnOnLocaleProp = void 0;
var _lodestarUtils = require("@smartsheet/lodestar-utils");
const makeWarnOnLocaleProp = componentName => {
  return (0, _lodestarUtils.warnOnce)(componentName + ": The locale prop is currently optional but will be required in a future major " + "version of lodestar-core. Please specify the locale prop. If you do not, it will " + `default to "en" which will probably result in a bug.`);
};
exports.makeWarnOnLocaleProp = makeWarnOnLocaleProp;
//# sourceMappingURL=warnOnLocaleProp.js.map